import { TableToolbar, TableToolbarContent } from "@carbon/react";
import React, { useEffect, useState } from "react";

import { TableToolbarSearch } from "src/components/Tables/TableToolbarSearch";
import { debounceSearchTime } from "src/hooks/useSearch.ts";
import { useT } from "src/internationalization";
import { debounce } from "src/utils/functions.utils.ts";

type CustomersToolbarProps = {
  searchTerm: string;
  handleOnSearchTermChange: (value: string) => void;

  placeholder?: string;
};

export const CustomersToolbar: React.FC<CustomersToolbarProps> = ({
  searchTerm,
  handleOnSearchTermChange,

  placeholder,
}) => {
  const t = useT();
  const [currentSearchTerm, setCurrentSearchTerm] = useState(searchTerm);

  useEffect(() => {
    setCurrentSearchTerm(searchTerm);
  }, [searchTerm]);

  const debouncedSearch = React.useMemo(() => {
    return debounce(handleOnSearchTermChange, debounceSearchTime);
    // We don't want to re-create the debounced function on every render, it makes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setSearchTerm = (value: string) => {
    setCurrentSearchTerm(value);
    debouncedSearch(value);
  };

  return (
    <>
      <TableToolbar aria-label="data table toolbar">
        <TableToolbarContent>
          <TableToolbarSearch
            placeholder={placeholder || t("page.customers.table.search.placeholder")}
            onSearchChange={setSearchTerm}
            search={currentSearchTerm}
          />
        </TableToolbarContent>
      </TableToolbar>
    </>
  );
};
